import React from "react"
import "./Main.scss"
import TopBanner from "../../components/TopBanner/TopBanner"
import PriceCalculator from "../../components/CalculatorFrame/CalculatorFrame"
import LandingFeatures from "../../components/LandingFeatures/LandingFeatures"
import LandingHelp from "../../components/LandingHelp/LandingHelp"
import LandingContent from "../../components/LandingContent/LandingContent"

class Main extends React.Component {
    componentDidMount() {
        this.moveToHash()
    }

    moveToHash() {
        const hash = window.location.hash
        if ( hash ) {
            const element = document.querySelector(hash)
            if ( element ) {
                element.scrollIntoView({ behavior: "smooth" })
            }
        }
    }

    render() {
        return (
            <section className="Main">
                <TopBanner />
                <PriceCalculator />
                <LandingContent />
                <LandingFeatures />
                <LandingHelp calculateLabel="Рассчитать стоимость" />
            </section>
        )
    }
}

export default Main
